const Permissions = Object.freeze({
	Users: {
		view: 'UsersV',
		add: 'AUsers',
		update: 'UUsers',
		delete: 'DUsers',
	},
	Branches: {
		view: 'BranV',
		add: 'ABran',
		update: 'UBran',
		delete: 'DBran',
		addBranchNote: 'BranAN',
		changeStatus: 'ChBranS',
	},
	Roles: {
		view: 'RolesV',
		add: 'ARoles',
		update: 'URoles',
		delete: 'DRoles',
	},
	IntegratedCustomers: {
		view: 'ICV',
		add: 'AIC',
		update: 'UIC',
		delete: 'DIC',
	},
	IntegratedCustomerBranches: {
		view: 'VICB',
		add: 'AICB',
		delete: 'DICB',
	},
	InactiveReasons: {
		view: 'InacReV',
		add: 'AInacRe',
		update: 'UInacRe',
		delete: 'DInacRe',
	},
	EndContractReasons: {
		view: 'EndCRV',
		add: 'AEndCR',
		update: 'UEndCR',
		delete: 'DEndCR',
	},
	GeneralSettings: {
		view: 'GSV',
		updateSettings: 'UGS',
		generateTookanWebhookSecret: 'GSGWS',
	},
	WebsitePartnerLogos: {
		view: 'VWPL',
		add: 'AWPL',
		update: 'UWPL',
		delete: 'DWPL',
	},
	Stores: {
		view: 'StoV',
		add: 'ASto',
		update: 'USto',
		changeStatus: 'ChStoS',
	},
	StoreChannels: {
		view: 'VSC',
		add: 'ASC',
		update: 'USC',
		delete: 'DSC',
	},
	Contracts: {
		view: 'ContV',
		add: 'ACont',
		delete: 'DCont',
		update: 'UCont',
		end: 'EndCont',
		updateDocuments: 'UDCont',
	},
	Cities: {
		view: 'CityV',
		add: 'ACity',
		update: 'UCity',
		delete: 'DCity',
	},
	CitiesCycle: {
		view: 'VCC',
		add: 'ACC',
		update: 'UCC',
		delete: 'DCC',
	},
	CyclesPripority: {
		view: 'VCCP',
		add: 'ACCP',
		update: 'UCCP',
		delete: 'DCCP',
	},
	Districts: {
		view: 'DistV',
		add: 'ADist',
		update: 'UDist',
		delete: 'DDist',
	},
	PartnerRoles: {
		view: 'VPR',
		add: 'APR',
		update: 'UPR',
		delete: 'DPR',
	},
	VehicleTypes: {
		view: 'VTV',
		add: 'AVT',
		update: 'UVT',
		delete: 'DVT',
	},
	Companies: {
		view: 'CmpV',
		add: 'ACmp',
		update: 'UCmp',
		logs: 'CmpLog',
	},
	Drivers: {
		view: 'DrV',
		add: 'ADr',
		update: 'UDr',
		endSession: 'DrES',
		test: 'DrTest',
		logs: 'DrLog',
	},
	DriverProfiles: {
		view: 'DrPV',
		addCmp: 'ADrCmp',
		startWork: 'SWDr',
		startWorkDate: 'SWD',
		endWorkDate: 'EWD',
		clear: 'CDr',
		block: 'BDr',
		logs: 'DrPLog',
	},
	DriverGroups: {
		view: 'DrGV',
		add: 'ADrG',
		update: 'UDrG',
		logs: 'DrGLog',
	},
	DriverNotes: {
		view: 'DrNV',
		add: 'ADrN',
		update: 'UDrN',
	},
	PartnerUsers: {
		view: 'VPU',
		add: 'APU',
		update: 'UPU',
		delete: 'DPU',
	},
	OperationsWorkingHours: {
		view: 'VOWH',
		update: 'UOWH',
	},
	Zones: {
		view: 'VZS',
		update: 'UZS',
	},
	ScheduledZones: {
		view: 'VSZ',
		create: 'CSZ',
		update: 'USZ',
	},
	LiveMonitoring: {
		view: 'VLM',
		cancel: 'CLM',
		forceComplete: 'FCOLM',
		viewLogs: 'VLOLM',
		autoSwap: 'ASLM',
		viewOrderMap: 'OMLM',
		manualOrderAssign: 'MOALM',
		addOrderComment: 'OCLM',
		deleteOrderComment: 'DOCLM',
		enableSchedule: 'ECOSLM',
	},
	CancellationReasons: {
		view: 'VCR',
		create: 'ACR',
		update: 'UCR',
		delete: 'DCR',
	},
	Map: {
		view: 'VM',
	},
	Orders: {
		view: 'VO',
		cancel: 'CO',
		forceComplete: 'FCO',
		viewLogs: 'VLO',
		export: 'EO',
		addOrderComment: 'OCO',
		deleteOrderComment: 'DOCO',
		reverseCancel: 'RCO',
	},
	FailedOrders: {
		view: 'FOV',
		viewHistory: 'FOVH',
		approve: 'FOA',
		reject: 'FOR',
		pending: 'FOP',
		create: 'FOU',
	},
	DriverLiveTracking: {
		view: 'VDLT',
		addZones: 'AZDLT',
		zonesLog: 'ZLDLT',
		hoursLog: 'HLDLT',
		driverDeviceInformation: 'VDPDLT',
		addHours: 'AHDLT',
		refreshDriverStatus: 'RDSDLT',
		endSession: 'ESDLT',
		resumeSession: 'RSDLT',
	},
	DriversPerformance: {
		view: 'VDP',
		logs: 'WHLDP',
		addTime: 'ATDP',
		addOvertime: 'AOTDP',
		applyAbsentFees: 'AAFDP',
	},
	FineReason: {
		view: 'VFRs',
		add: 'AFRs',
		update: 'UFRs',
		delete: 'DFRs',
	},
	ForceCompleteReason: {
		view: 'VFCRs',
		add: 'AFCRs',
		update: 'UFCRs',
		delete: 'DFCRs',
	},
	DriverOffDays: {
		view: 'VDOD',
		update: 'UDOD',
	},
	DriverWallet: {
		view: 'VDWs',
		add: 'ADWs',
	},
	DriverFine: {
		view: 'VDFs',
		apply: 'AOFS',
		approve: 'ADFs',
		reject: 'RDFs',
	},
	APILog: {
		view: 'VARL',
	},
	Deliverect: {
		view: 'DELV',
		integrate: 'ADEL',
		remove: 'DDEL',
		log: 'LDEL',
	},
	Foodics: {
		view: 'FDCV',
		integrate: 'AFDC',
		remove: 'DFDC',
		log: 'LFDC',
	},
	FailedOrderReasons: {
		view: 'FORV',
		create: 'FORA',
		update: 'FORU',
		delete: 'FORD',
	},
	FoodAggregators: {
		view: 'FAMV',
		create: 'FAMA',
		update: 'FAMU',
		delete: 'FAMD',
	},
	CustomerLocations: {
		view: 'CLV',
		delete: 'CLD',
	},
	Salla: {
		view: 'VSalla',
		integrate: 'ISalla',
		log: 'LSalla',
	},
});

export default Permissions;
